module.exports = __webpack_public_path__ + "img/logo-red.4a8c7247.png";